
import BasicFormGroup from './BasicFormGroup'
import ValidationFeedback from './ValidationFeedback'
import { ValidationProvider } from 'vee-validate'
export default {
  components: {
    BasicFormGroup,
    ValidationFeedback,
    ValidationProvider
  },
  inheritAttrs: false,
  props: ['value'],
  data: () => ({
    isFocused: false
  }),
  computed: {
    listeners () {
      return {
        ...this.$listeners,
        focus: (event) => {
          this.isFocused = true
          this.$emit('focus', event)
        },
        blur: (event) => {
          this.isFocused = false
          this.$emit('blur', event)
        },
        // This ensures that the component works with v-model
        input: (event) => {
          if (typeof event === 'boolean' || typeof event === 'string' || event instanceof Date || !event || !event.target) {
            this.$emit('input', event)
          } else {
            this.$emit('input', event.target.value)
          }
        }
      }
    },
    labelIsUp () {
      return this.isFocused || (this.value !== undefined && this.value !== null && this.value !== '')
    },
    getValidation () {
      const validation = {
        required: this.$attrs.required !== undefined && this.$attrs.required !== false,
        ...this.$attrs.validation
      }
      if (this.$attrs.min !== undefined) validation['min_value'] = this.$attrs.min
      if (this.$attrs.max !== undefined) validation['max_value'] = this.$attrs.max

      return validation
    },
    name () {
      return this.$attrs.name || this.$attrs.label
    },
    id () {
      return this.$attrs.id || ('formElement' + getNextFormElementId())
    },
    veeField () {
      return this.id + '-' + this.name
    },
    model: {
      get () {
        return this.value
      },
      set (val) {
        if (val !== this.value) {
          this.$emit('input', val)
        }
      }
    }
  }
}

let formElementIdCounter = 0 // is static; distributes unique ids

function getNextFormElementId () {
  // this distributes ids so that it doesn't have to be set by the developer
  const nextId = formElementIdCounter++
  if (formElementIdCounter > 10000) {
    // to prevent possible memoryleak (although unlikely) reset counter
    formElementIdCounter = 0
  }
  return nextId
}
